import React from "react";
import { ShieldCheck, Banknote } from "lucide-react";
import PageHero from "../components/PageHero";
import ContactForm from "../components/ContactForm";
import { Seo } from "../components/Seo";
import { RelatedServices } from "../components/RelatedServices";
import { IconFeatureCard, SectionIntro } from "../components/IconFeatureCard";
import { consultingAreas, images } from "../mock";

const ConsultingIntro = () => (
  <section className="py-20">
    <div className="container-wide max-w-3xl mx-auto text-center">
      <p className="text-lg text-slate-500 leading-relaxed">
        IT consulting involves providing expert advice and services to organizations to help them improve their IT infrastructure, systems, and processes. Our consultants work with you to understand your business needs and technology challenges, offering solutions across a wide range of areas.
      </p>
    </div>
  </section>
);

const ConsultingAreas = () => (
  <section className="pb-20">
    <div className="container-wide">
      <SectionIntro eyebrow="Areas of Expertise" title="What our consulting covers" />
      <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {consultingAreas.map((a) => (
          <IconFeatureCard key={a.title} icon={a.icon} title={a.title} body={a.body} />
        ))}
      </div>
    </div>
  </section>
);

const ValueProp = ({ icon: Icon, title, children }) => (
  <div className="rounded-2xl bg-white p-9 border border-slate-100 shadow-sm">
    <span className="flex h-13 w-13 items-center justify-center rounded-2xl bg-primary/10 text-primary p-3">
      <Icon className="h-7 w-7" />
    </span>
    <h3 className="mt-5 font-display text-xl font-bold text-slate-900">{title}</h3>
    <p className="mt-3 text-slate-500 leading-relaxed">{children}</p>
  </div>
);

const ConsultingValueProps = () => (
  <section className="py-20 bg-slate-50">
    <div className="container-wide grid gap-6 md:grid-cols-2">
      <ValueProp icon={ShieldCheck} title="Tailored Solutions">
        We understand that every business is unique, which is why we provide tailored solutions to meet the specific needs of our clients — designed to help small businesses optimize their technology and achieve their goals.
      </ValueProp>
      <ValueProp icon={Banknote} title="Affordable Pricing">
        We believe small businesses should have access to high-quality IT consulting services without breaking the bank. That's why we offer affordable pricing options to fit any budget.
      </ValueProp>
    </div>
  </section>
);

const ConsultingContact = () => (
  <section id="contact" className="py-20">
    <div className="container-wide">
      <div className="max-w-2xl mx-auto text-center mb-12">
        <span className="inline-block text-xs font-semibold uppercase tracking-[0.18em] text-primary mb-3">Contact Us</span>
        <h2 className="font-display text-3xl sm:text-4xl font-extrabold text-slate-900">Drop us a line!</h2>
      </div>
      <ContactForm compact source="Consulting" />
    </div>
  </section>
);

const ConsultingPage = () => (
  <div>
    <Seo
      title="IT Consulting Services — Cloud, Security & Strategy | OzzieeTech"
      description="Expert IT consulting for growing businesses: cloud migration, cybersecurity, network architecture and digital transformation strategy with transparent pricing."
      path="/consulting"
    />
    <PageHero
      eyebrow="IT Consulting"
      title="Expert IT Consulting"
      sub={"We help organisations improve their IT infrastructure, systems and processes — offering solutions to optimise and enhance your technology landscape."}
      image={images.consulting}
    />
    <ConsultingIntro />
    <ConsultingAreas />
    <ConsultingValueProps />
    <RelatedServices current="/consulting" />
    <ConsultingContact />
  </div>
);

export default ConsultingPage;
